import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class ContractClauseService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cm/contractClauses')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-clipboard-list';
    }

    getObjectLabels(): string[] {
        return ['clauseNumber', 'clauseName'];
    }

}
